(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.TCSDelivery = api;
})(typeof self !== 'undefined' ? self : this, function () {
  var MS_DAY = 86400000;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function toISO(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
  }

  function utcMidnight(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  }

  function addDays(date, n) { return new Date(date.getTime() + n * MS_DAY); }

  // Calendar date + hour of `date` as seen in an IANA time zone (e.g. Europe/London),
  // so the noon cut-off and "today" follow UK clock time through BST/GMT changes.
  // Returns null when no zone is given or Intl can't resolve it → caller uses UTC.
  function localParts(date, timeZone) {
    if (!timeZone || typeof Intl === 'undefined' || !Intl.DateTimeFormat) return null;
    try {
      var fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: timeZone, hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit'
      });
      var p = {};
      fmt.formatToParts(date).forEach(function (part) { p[part.type] = part.value; });
      var hour = parseInt(p.hour, 10);
      if (hour === 24) hour = 0;                       // some engines print midnight as "24"
      if (isNaN(hour) || !p.year || !p.month || !p.day) return null;
      return { year: +p.year, month: +p.month, day: +p.day, hour: hour };
    } catch (e) { return null; }
  }

  function isBlocked(date, blockedWeekdays, blockedSet, openSet) {
    var iso = toISO(date);
    if (openSet[iso]) return false;                      // explicitly opened overrides weekday block
    if (blockedSet[iso]) return true;                    // explicitly blocked date
    return blockedWeekdays.indexOf(date.getUTCDay()) !== -1;
  }

  function computeAvailability(nowUTC, opts) {
    var blockedWeekdays = opts.blockedWeekdays || [];
    var blockedSet = {};
    (opts.blockedDates || []).forEach(function (d) { blockedSet[d] = true; });
    var openSet = {};
    (opts.extraOpenDates || []).forEach(function (d) { openSet[d] = true; });

    // "Today" and the current hour are taken in opts.timeZone when set (the shop's
    // local clock); otherwise in UTC. `cutoffHour` is an hour in that zone;
    // `cutoffHourUTC` is the legacy UTC-only spelling kept for older islands.
    var local = localParts(nowUTC, opts.timeZone);
    var today = local
      ? new Date(Date.UTC(local.year, local.month - 1, local.day))
      : utcMidnight(nowUTC);
    var hourNow = local ? local.hour : nowUTC.getUTCHours();
    var cutoff = opts.cutoffHour != null ? opts.cutoffHour : opts.cutoffHourUTC;
    // No cutoff (null/undefined) → flat next-day; a numeric cutoff keeps the
    // before/after-noon split used for courier delivery.
    var offset;
    if (cutoff == null) offset = 1;
    else offset = hourNow < cutoff ? 1 : 2;
    var cursor = addDays(today, offset);
    while (isBlocked(cursor, blockedWeekdays, blockedSet, openSet)) {
      cursor = addDays(cursor, 1);
    }
    var floor = toISO(cursor);

    var last = addDays(today, opts.maxDaysAhead);
    var available = [];
    var walk = cursor;
    while (walk.getTime() <= last.getTime()) {
      if (!isBlocked(walk, blockedWeekdays, blockedSet, openSet)) available.push(toISO(walk));
      walk = addDays(walk, 1);
    }

    var highlighted = null;
    if (opts.highlightedDate && available.indexOf(opts.highlightedDate) !== -1) {
      highlighted = opts.highlightedDate;
    }

    return { floor: floor, availableDates: available, highlighted: highlighted };
  }

  // Payload for the Storefront API's cart delivery preference, which pre-selects
  // the delivery method at checkout (Ship vs Collection tab + pickup location).
  // pickupHandles maps a collect method key to its Shopify location ID (numeric).
  // A collect method with no configured location still opens the Collection tab.
  function checkoutPreference(methodKey, pickupHandles) {
    var isCollect = typeof methodKey === 'string' && methodKey.indexOf('collect_') === 0;
    if (!isCollect) return { deliveryMethod: ['SHIPPING'], pickupHandle: [] };
    var handle = pickupHandles && pickupHandles[methodKey];
    return { deliveryMethod: ['PICK_UP'], pickupHandle: handle ? [String(handle)] : [] };
  }

  return { computeAvailability: computeAvailability, toISO: toISO, checkoutPreference: checkoutPreference };
});
